import Icon from '@forwardflow/ui/Icons'
import { Progress, Select, Skeleton } from 'antd'
import { useGetCampaignsOverview } from '../../hooks'
import { useState } from 'react'
import { secondsToReadableTime } from '@forwardflow/helpers/utils'
import { formatNumber } from '@forwardflow/helpers/utils/formatNumber'
import { ContractIcon } from '@forwardflow/assets/svg/ContractIcon'
import { LeadsNurturedIcon } from '@forwardflow/assets/svg/LeadsNurturedIcon'

export const LeadConversationStats = ({
   selectedDays,
}: {
   selectedDays: string
}) => {
   const [selectedType, setSelectedType] = useState('all-leads')
   const { data: overviewData, isLoading } = useGetCampaignsOverview(
      selectedType,
      selectedDays,
      'days'
   )
   const leadStatsTypeOptions = [
      { value: 'active-lead-sources', label: 'Campaigns' },
      { value: 'all-leads', label: 'All Lead Sources' },
   ]
   const handleSelectChange = (value: string) => {
      setSelectedType(value)
   }
   return (
      <div>
         <div className="flex items-center my-5">
            <p className="font-medium">Lead conversion stats</p>
            <div className="ml-4 flexc">
               <Select
                  className="min-w-[150px] dashboard-select !h-9 rounded"
                  defaultValue="all-leads"
                  onChange={handleSelectChange}
                  options={leadStatsTypeOptions}
               />
            </div>
         </div>
         {isLoading ? (
            <>
               <Skeleton active className="mb-6" />
               <Skeleton active className="mb-6" />
               <Skeleton active />
            </>
         ) : (
            <>
               <div className="bg-primary/20 border border-white/10 rounded-[4px] mb-4">
                  <div className="relative flex border-b h-36 bg-primary/20 border-white/10">
                     <div className="flex-col flex-1 py-5 text-center border-r border-white/20 px-7 flexc">
                        <div className="h-6 mb-3 flexc shrink-0">
                           <LeadsNurturedIcon className="mx-auto" />
                        </div>
                        <p className="text-white/70 text-[14px] font-medium mb-1">
                           Leads nurtured
                        </p>
                        <p className="text-[32px] font-medium">
                           {formatNumber(overviewData?.metrics?.totalPeople) ||
                              'N/A'}
                        </p>
                     </div>
                     <div className="flex-col flex-1 py-5 text-center border-r flexc border-white/20 px-7">
                        <div className="h-6 mb-3 flexc shrink-0 ">
                           <Icon
                              name="Calendar"
                              className="mx-auto fill-[#AB7AE0] scale-125"
                           />
                        </div>

                        <p className="text-white/70 text-[14px] font-medium mb-1">
                           Appointments
                        </p>
                        <p className="text-[32px] font-medium">
                           {formatNumber(
                              overviewData?.metrics?.totalAppointments
                           ) || 'N/A'}
                        </p>
                     </div>
                     <div className="flex-col flex-1 py-5 text-center px-7 flexc">
                        <div className="h-6 mb-3 flexc shrink-0">
                           <ContractIcon className="mx-auto" />
                        </div>

                        <p className="text-white/70 text-[14px] font-medium mb-1">
                           Contracts
                        </p>
                        <p className="text-[32px] font-medium">
                           {formatNumber(
                              overviewData?.metrics?.totalContracts
                           ) || 'N/A'}
                        </p>
                     </div>
                     {/* <LeadConversationChart data={overviewData?.chart} /> */}
                  </div>

                  <div className="flex flex-wrap text-center">
                     <div className="flex-1 py-5 px-7">
                        <p className="text-white/70 text-[14px] font-medium mb-1">
                           Speed to Lead
                        </p>
                        <div className="flexc gap-x-2">
                           <span className="text-[24px] font-medium">
                              {secondsToReadableTime(
                                 overviewData?.metrics?.avgSpeedToLead ?? 0
                              )}
                           </span>
                           <div className="px-1 rounded h-7 flexc">
                              {(overviewData?.metrics?.avgSpeedToLead ?? 0) >
                              (overviewData?.metrics
                                 ?.historicalAvgSpeedToLead ?? 0) ? (
                                 <Icon
                                    name="GreenArrow"
                                    className="scale-110 rotate-180"
                                 />
                              ) : (
                                 <Icon
                                    name="GreenArrow"
                                    className="scale-110"
                                 />
                              )}
                           </div>
                        </div>
                     </div>
                     <div className="flex-1 py-5 px-7">
                        <p className="text-white/70 text-[14px] font-medium mb-1">
                           Lead to Appt.
                        </p>
                        <div className="flexc gap-x-2">
                           <span className="text-[24px] font-medium">
                              {secondsToReadableTime(
                                 overviewData?.metrics?.avgLeadToAppointment ??
                                    0
                              )}
                           </span>
                           <div className="px-1 rounded h-7 flexc">
                              {(overviewData?.metrics?.avgLeadToAppointment ??
                                 0) >
                              (overviewData?.metrics
                                 ?.historicalAvgLeadToAppointment ?? 0) ? (
                                 <Icon
                                    name="GreenArrow"
                                    className="scale-110 rotate-180"
                                 />
                              ) : (
                                 <Icon
                                    name="GreenArrow"
                                    className="scale-110"
                                 />
                              )}
                           </div>
                        </div>
                     </div>
                     <div className="flex-1 py-5 px-7">
                        <p className="text-white/70 text-[14px] font-medium mb-1">
                           Appt. to Contract
                        </p>
                        <div className="flexc gap-x-2">
                           <span className="text-[24px] font-medium">
                              {secondsToReadableTime(
                                 overviewData?.metrics
                                    ?.avgAppointmentToContract ?? 0
                              )}
                           </span>
                           <div className="px-1 rounded h-7 flexc">
                              {(overviewData?.metrics
                                 ?.avgAppointmentToContract ?? 0) >
                              (overviewData?.metrics
                                 ?.historicalAvgAppointmentToContract ?? 0) ? (
                                 <Icon
                                    name="GreenArrow"
                                    className="scale-110 rotate-180"
                                 />
                              ) : (
                                 <Icon
                                    name="GreenArrow"
                                    className="scale-110"
                                 />
                              )}
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="flex mb-4 gap-x-4">
                  <div className="bg-[#303137] rounded p-7 flex-1">
                     <p className="text-[14px] mb-3 font-medium">
                        Appointment Rate
                     </p>
                     <div className="flex items-center gap-x-2">
                        <span className="text-[24px] font-medium">
                           {overviewData?.metrics?.appointmentRate}
                        </span>
                        <div className="px-1 rounded h-7 flexc">
                           {(overviewData?.metrics?.appointmentRate ?? 0) >
                           (overviewData?.metrics?.historicalAppointmentRate ??
                              0) ? (
                              <Icon
                                 name="GreenArrow"
                                 className="scale-110 rotate-180"
                              />
                           ) : (
                              <Icon name="GreenArrow" className="scale-110" />
                           )}
                        </div>
                     </div>
                  </div>
                  <div className="bg-[#303137] rounded p-7 flex-1">
                     <p className="text-[14px] mb-3 font-medium">
                        Contact Attempts / Lead
                     </p>
                     <div className="flex items-center gap-x-2">
                        <span className="text-[24px] font-medium">
                           {overviewData?.metrics?.contactAttemptsPerPerson}
                        </span>
                        <div className="px-1 rounded h-7 flexc">
                           {(overviewData?.metrics?.contactAttemptsPerPerson ??
                              0) >
                           (overviewData?.metrics
                              ?.historicalContactAttemptsPerPerson ?? 0) ? (
                              <Icon
                                 name="GreenArrow"
                                 className="scale-110 rotate-180"
                              />
                           ) : (
                              <Icon name="GreenArrow" className="scale-110" />
                           )}
                        </div>
                     </div>
                  </div>
               </div>
               <div className="bg-[#303137] rounded p-7 flex-1 hidden">
                  <p className="text-[14px] mb-3 font-medium">Response rate</p>
                  <div className="flex items-center gap-x-2">
                     <div className="flex items-center gap-x-2">
                        <span className="text-[24px] font-medium">
                           {overviewData?.metrics?.responseRate}
                        </span>
                        <div className="px-1 rounded h-7 flexc">
                           {(overviewData?.metrics?.responseRate ?? 0) >
                           (overviewData?.metrics?.historicalResponseRate ??
                              0) ? (
                              <Icon
                                 name="GreenArrow"
                                 className="scale-110 rotate-180"
                              />
                           ) : (
                              <Icon name="GreenArrow" className="scale-110" />
                           )}
                        </div>
                     </div>
                     <Progress
                        size={['100%', 20]}
                        strokeColor={'#9061DA'}
                        trailColor={'#16171C'}
                        percent={
                           (overviewData?.metrics?.responseRate as number) * 100
                        }
                        showInfo={false}
                     />
                  </div>
               </div>
            </>
         )}
      </div>
   )
}
